(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js') >= 0) return;  svs.modules.push('/components/components/adobe-target-payload-handler/assets/javascripts/intersection-observer.js'); "use strict";

var logger = svs.core.log.getLogger('components:adobe-target-payload-handler');
var visualElements = new Set();
var elementSent = new Set();
var intersectionObserver;
var intersectionObserverOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [0.4, 0.5]
}; 

var dataAttributes = ['[data-crm-mbox]'];
var TIME_TO_IMPRESSION = 500;

function timeInViewport(element) {
  var _svs$components$adobe = svs.components.adobeTargetPayloadHandler,
      sendView = _svs$components$adobe.sendView,
      setupClickInMbox = _svs$components$adobe.setupClickInMbox;
  return setTimeout(function () {
    if (visualElements.has(element) && !elementSent.has(element)) {
      sendView(element);
      setupClickInMbox(element);
      elementSent.add(element);
      visualElements.delete(element);
    }
  }, TIME_TO_IMPRESSION);
}

function handleIntersection(entries) {
  entries.forEach(function (entry) {
    var el = entry.target;

    if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
      visualElements.add(el);
      timeInViewport(el);
    } else {
      visualElements.delete(el);
    }
  });
}

function setupImpressionTracking() {
  if ('IntersectionObserver' in window) {
    intersectionObserver = new IntersectionObserver(handleIntersection, intersectionObserverOptions);

    try {
      var elementsToTrack = document.querySelectorAll(dataAttributes.join(','));

      for (var i = 0; i < elementsToTrack.length; i++) {
        intersectionObserver.observe(elementsToTrack[i]);
      } 

    } catch (e) {
      logger.warn("Unexpected error:".concat(e.message));
    }
  } else {
  }
} 


$(function () {
  setupImpressionTracking();
}); 

$(window).on('unload', function () {
  $(window).off('load', setupImpressionTracking);
});
 })(window);